import { splitMarketplace } from "./format";

/**
 * A source name that truncates mid-string, never the marketplace suffix (UX §5):
 * "Amazon Sales & Tra… UK", not "Amazon Sales & Traffic…". The full name stays in
 * the title for hover.
 */
export function SourceName({ name }: { name: string }) {
  const { body, suffix } = splitMarketplace(name);
  return (
    <span className="flex min-w-0 items-baseline" title={name}>
      <span className="min-w-0 truncate">{body}</span>
      {suffix && <span className="shrink-0 whitespace-pre" data-marketplace>{` ${suffix}`}</span>}
    </span>
  );
}
